import { queryClient } from 'providers/queryClient';
import { useDelete } from 'react-admin';
import { DeleteDialog } from 'shared/mui/Dialogs';
import { UPLOAD_FILES } from 'shared/widgets/TableFileViewer/hooks/useGetFiles';
import { FileData } from 'types/embedded/fileData';

type Props = {
  onClose: VoidFunction;
  open: boolean;
  record?: FileData;
};

export const TableFileViewerDeleteDialog: React.FC<Props> = ({ onClose, open, record }) => {
  const [deleteOne, { isLoading }] = useDelete(
    'upload_files',
    {
      id: `admin/upload_files/${record?.id}` || '',
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: [UPLOAD_FILES] });
        onClose();
      },
    },
  );

  return (
    <DeleteDialog
      details={`После подтверждения, вложенный файл ${record?.name} будет недоступен для восстановления.`}
      isLoading={isLoading}
      onClose={onClose}
      onDelete={deleteOne}
      onSuccess={onClose}
      open={open}
      title="Удалить вложение?"
      width={500}
    />
  );
};
